<template>
  <div>
    <!--<van-sticky>-->
    <!--<van-notice-bar-->
    <!--background="red"-->
    <!--color="#ffffff"-->
    <!--mode="closeable"-->
    <!--left-icon="point-gift-o"-->
    <!--text="爱灸堂商城商品买1送1，拍1个发2个（特价商品除外）仅限6月25日，没有任何分润和各种层级代理"-->
    <!--/>-->
    <!--</van-sticky>-->
    <div class="app" v-cloak>
      <!--<transition :name="transitionName">-->
      <keep-alive :include="include" :max="10">
        <router-view class="router" ref="router"></router-view>
      </keep-alive>
      <!--</transition>-->
    </div>
    <component :is="showBuyPop" />
    <Footer v-if="footer === true" />
    <Home v-if="home === true" />
    <!--<Ad-window />-->
    <!--<CouponPop />-->
  </div>
</template>
<script>
function isKeepAlive($route) {
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}
// import { NoticeBar as VanNoticeBar, Sticky as VanSticky } from "vant";
import Footer from "@components/Footer";
import Home from "@components/Home";
import BuyPop from "@components/BuyPop";
// import CouponPop from "@components/CouponPop";
import { mapGetters } from "vuex";
// import AdWindow from "@components/AdWindow";
import { openShareAll } from "@libs/wechat";
import { getShare } from "@api/public";
import { isWeixin } from "@utils/index";

export default {
  data() {
    return {
      transitionName: "fold-right",
      include: isKeepAlive(this.$route) ? [this.$route.name] : [],
      history: [],
      showBuyPop: "BuyPop"
    };
  },
  provide() {
    return {
      app: this
    };
  },
  computed: mapGetters(["footer", "home", "isLogin"]),
  components: {
    // AdWindow,
    BuyPop,
    // VanNoticeBar,
    // VanSticky,
    // CouponPop,
    Footer,
    Home
  },
  watch: {
    $route(to, from) {
      if (["AuthInfo"].includes(to.name)) this.showBuyPop = "";
      const lastPath = this.history[this.history.length - 1] || {},
        { isReplace, isBack } = this.$router;

      if (lastPath.path === to.path) {
        this.transitionName = "fold-right";
        this.history.pop();
      } else {
        this.transitionName = "fold-left";
        if (!isReplace) this.history.push({ path: from.path, name: from.name });
      }

      if (isKeepAlive(to) && to.name !== "Login") {
        !this.include.includes(to.name) && this.include.push(to.name);
      }

      if (isKeepAlive(from) && isBack) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }

      this.$router.isBack = false;
      this.$router.isReplace = false;

      console.log(this.transitionName, "change");
    }
  },
  mounted: function() {
    // this.setOpenShare();
  },
  methods: {
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style lang="scss">
[v-cloak] {
  display: none !important;
}
$dmap: (
  s: flex-start,
  e: flex-end,
  c: center
);
@mixin rev-flex($direction) {
  flex-direction: $direction;
  &-r {
    flex-direction: #{$direction}-reverse; //ubv-r纵向 反向排列
  }
  @each $key, $value in $dmap {
    &-#{$key} {
      @if $direction== "column" {
        align-items: $value;
      } @else {
        justify-content: $value;
      }
    }
  }
}
.u-t {
  align-items: baseline;
}
.tx-dian {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #3d4245;
}
.no-warp {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.tx-c {
  text-align: center;
}
.ub {
  display: flex;
  //排列方向
  &h {
    @include rev-flex(row); //.ubh 横向排列 ubh-r横向 反向排列
  }
  &v {
    @include rev-flex(column); //.ubv 纵向排列 ubv-r纵向 反向排列
  }
  &-sa {
    justify-content: space-around;
  }
  &-sb {
    justify-content: space-between;
  }
  &-warp {
    flex-wrap: wrap;
  }
  &-c {
    align-content: center;
  }
}
@each $key, $value in $dmap {
  .uf-#{$key} {
    align-self: $value;
  }
}
.ub {
  &-st {
    align-items: stretch;
  }
}
.uf {
  &-st {
    align-self: stretch;
  }
}
@for $i from 0 through 4 {
  .uf {
    &#{$i} {
      flex-grow: $i;
    }
  }
}
.rel {
  position: relative;
}
.abs {
  position: absolute;
}
a[title="站长统计"] {
  display: none;
}
.router {
  position: absolute;
  width: 100%;
}

.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.5s;
}

.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.5s;
}

@keyframes fold-left-in {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-left-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.5s;
}

.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.5s;
}

@keyframes fold-right-in {
  0% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-right-out {
  0% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
</style>
